// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_dWy","cls2":"PodcastLibraryCarouselAd-cls2_fxn PodcastLibraryCarouselAd-cls1_dWy"};